import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { IGlobalState, reducer } from "../reducers/IndexReducer";

/*
 * We're giving State interface to create store
 * store is type of State defined in reducers
 */
const store = createStore<IGlobalState, any, any, any>(
  reducer,
  applyMiddleware(thunk)
);

export default store;



// WEBPACK FOOTER //
// ./src/scripts/store/Store.ts